import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1.60246, y: 1.4174, width: 10.1653, height: 10.1653, rx: 5.08267, stroke: "currentcolor", strokeWidth: 1.42855 }), /* @__PURE__ */ React.createElement("path", { d: "M0.888184 11.9837L12.4821 0.703125", stroke: "currentcolor", strokeWidth: 1.42855 }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
